import { type ReactNode, useId } from "react";
import { cardStyles } from "../../../core/Card.styles.js";
import { Text } from "../../../core/Text.js";

export interface FairnessCardProps {
  title: string;
  description: string;
  children: ReactNode;
}

/** One tool of the fairness page: a surface named by its heading, with what it does under it. */
export function FairnessCard({ title, description, children }: FairnessCardProps) {
  const headingId = useId();
  return (
    <section
      aria-labelledby={headingId}
      className={cardStyles({ radius: "3xl", className: "flex min-w-0 flex-col gap-5 p-5 sm:p-6" })}
    >
      <div className="flex flex-col gap-1">
        <Text id={headingId} as="h2" variant="heading-h1" tone="primary">
          {title}
        </Text>
        <Text variant="body-b2" tone="secondary" className="break-words">
          {description}
        </Text>
      </div>
      {children}
    </section>
  );
}
